import { render, staticRenderFns } from "./FinanceMain.vue?vue&type=template&id=3ddc54d4&scoped=true&"
import script from "./FinanceMain.vue?vue&type=script&lang=js&"
export * from "./FinanceMain.vue?vue&type=script&lang=js&"
import style0 from "./FinanceMain.vue?vue&type=style&index=0&id=3ddc54d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddc54d4",
  null
  
)

export default component.exports